import { l } from '@manychat/manyui'

import { UpgradeSource, billing } from 'common/billing'
import { AudienceApi } from 'shared/api/requests/audience'
import { FilterFieldValuePayload } from 'shared/api/requests/audience/schemas'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchFieldValues = createAsyncAction(
  'subscribers/availableValues',
  async (payload: FilterFieldValuePayload) => {
    const { field, query = '' } = payload

    return await AudienceApi.availableValues({
      query: {
        field,
        query,
      },
    })
  },
  {
    onBusinessError: (error) => {
      if (billing.isProError(error)) {
        error.handle()

        billing.handleProError(error, {
          source: UpgradeSource.SMART_SEGMENTS,
          message: l.translate(
            "You aren't able to activate Contact Segments on the current plan. Upgrade your plan to create and view Segments.",
          ),
          title: l.translate(
            'Unlock the ability to create Contact Segments with Manychat Pro Subscription',
          ),
        })
      }
    },
  },
)
